<template>
  <div>
    <div class="btn-group">
      <a-button
        v-for="btn in timeButtons"
        :key="btn.value"
        :type="dateType === btn.value ? 'primary' : 'default'"
        size="small"
        @click="dateTypeChange(btn.value)"
        >{{ btn.label }}</a-button
      >
    </div>
    <div class="my-charts" ref="myChart"></div>
  </div>
</template>

<script>
import { WCIOptions, WCITKOptions } from "./KeytypeChartOpt.js";

export default {
  name: "KeytypeChart",
  props: {},
  data() {
    return {
      WciKeytypeData: [],
      TkKeytypeData: [],
      ChartTitle: "",
      legendData: [],
      dateType: "week",
      timeButtons: [
        { label: "周", value: "week" },
        { label: "月", value: "month" },
        { label: "年", value: "year" },
        { label: "全部", value: "all" },
      ],
      wciUpSeriesData: [],
      wciDownSeriesData: [],
      tkUpSeriesData: [],
      tkDownSeriesData: [],
      ChartGrid: [],
      ChartSeries: [],
      ChartXAxis: [],
      ChartYAxis: [],
    };
  },
  methods: {
    SetData(wcidata, tkdata, title) {
      this.WciKeytypeData = wcidata || [];
      this.TkKeytypeData = tkdata || [];
      this.ChartTitle = title;

      this.legendData = [
        ...new Set(this.WciKeytypeData.map((item) => item.keyWord)),
      ];

      this.InitOptions();
    },
    cleanString(str) {
      if (!str || typeof str !== "string") return "";
      return str.replace(/[a-zA-Z\s\*\uff21-\uff5a\u3000]/g, "");
    },
    filterByDateType(data, dateType) {
      if (dateType === "all" || data.length === 0) return data;
      const now = new Date();
      let startDate;
      if (dateType === "week") {
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      } else if (dateType === "month") {
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      } else if (dateType === "year") {
        startDate = new Date(now.getTime() - 365 * 24 * 60 * 60 * 1000);
      }
      const startTime = parseInt(
        startDate.getFullYear().toString() +
          String(startDate.getMonth() + 1).padStart(2, "0") +
          String(startDate.getDate()).padStart(2, "0")
      );
      return data.filter((item) => item.infoTime >= startTime);
    },
    dateTypeChange(value) {
      this.dateType = value;
      this.InitOptions();
    },
    MapDataToAxis(dateValuePairs, masterDates, valueKey, fillNull) {
      const dateMap = {};
      dateValuePairs.forEach((item) => {
        dateMap[item.infoTime] = item[valueKey] || 0;
      });
      const fillValue = fillNull ? 0 : null;
      return masterDates.map((d) => {
        if (dateMap[d] !== undefined) return dateMap[d];
        return fillValue;
      });
    },
    SetWciDownChartData(masterDates) {
      const cleanChartTitle = this.cleanString(this.ChartTitle);
      let matchedItems = this.WciKeytypeData.filter((item) => {
        if (!item || !item.keyWord) return false;
        return this.cleanString(item.keyWord) === cleanChartTitle;
      });
      matchedItems = this.filterByDateType(matchedItems, this.dateType);

      const values = this.MapDataToAxis(matchedItems, masterDates, "totalScore");
      this.wciDownSeriesData = [
        {
          name: cleanChartTitle,
          type: "line",
          smooth: true,
          connectNulls: true,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgb(100, 181, 246)" },
              { offset: 1, color: "rgb(33, 150, 243)" },
            ]),
          },
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: values,
        },
      ];
      this.ChartXAxis[1].data = masterDates;
    },
    SetWciUpChartDate() {
      const allDates = [];
      let filteredData = this.filterByDateType(
        this.WciKeytypeData,
        this.dateType
      );
      this.wciUpSeriesData = this.legendData.map((keyword) => {
        const keywordData = filteredData.filter(
          (item) => item.keyWord === keyword
        );
        keywordData.forEach((item) => {
          if (!allDates.includes(item.infoTime)) {
            allDates.push(item.infoTime);
          }
        });
        const values = this.MapDataToAxis(
          keywordData,
          allDates,
          "totalScore",
          true
        );
        return {
          name: keyword,
          type: "line",
          stack: "Total",
          smooth: true,
          xAxisIndex: 0,
          yAxisIndex: 0,
          lineStyle: { width: 0 },
          showSymbol: false,
          label: { show: false, position: "top" },
          areaStyle: {},
          emphasis: { focus: "series" },
          data: values,
        };
      });
      this.ChartXAxis[0].data = allDates;
      return allDates;
    },
    SetTkUpChartData(masterDates) {
      if (this.TkKeytypeData.length === 0) {
        this.tkUpSeriesData = [];
        return;
      }
      let filteredData = this.filterByDateType(
        this.TkKeytypeData,
        this.dateType
      );
      this.tkUpSeriesData = this.legendData.map((keyword) => {
        const keywordData = filteredData.filter(
          (item) => item.keyWord === keyword
        );
        const mappedItems = keywordData.map((item) => ({
          infoTime: item.infoTime,
          combined: (item.searchScore || 0) + (item.topScore || 0),
        }));
        const values = this.MapDataToAxis(
          mappedItems,
          masterDates,
          "combined",
          true
        );
        return {
          name: keyword,
          type: "line",
          stack: "Total1",
          smooth: true,
          xAxisIndex: 2,
          yAxisIndex: 2,
          lineStyle: { width: 0 },
          showSymbol: false,
          label: { show: false, position: "top" },
          areaStyle: {},
          emphasis: { focus: "series" },
          data: values,
        };
      });
      this.ChartXAxis[2].data = masterDates;
    },
    SetTkDownChartData(masterDates) {
      if (this.TkKeytypeData.length === 0) {
        this.tkDownSeriesData = [];
        return;
      }
      const cleanChartTitle = this.cleanString(this.ChartTitle);
      let matchedItems = this.TkKeytypeData.filter((item) => {
        if (!item || !item.keyWord) return false;
        return this.cleanString(item.keyWord) === cleanChartTitle;
      });
      matchedItems = this.filterByDateType(matchedItems, this.dateType);

      const mappedItems = matchedItems.map((item) => ({
        infoTime: item.infoTime,
        combined: (item.searchScore || 0) + (item.topScore || 0),
      }));
      const values = this.MapDataToAxis(mappedItems, masterDates, "combined");
      this.tkDownSeriesData = [
        {
          name: cleanChartTitle,
          type: "line",
          smooth: true,
          connectNulls: true,
          xAxisIndex: 3,
          yAxisIndex: 3,
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgb(255, 167, 38)" },
              { offset: 1, color: "rgb(245, 124, 0)" },
            ]),
          },
          data: values,
        },
      ];
      this.ChartXAxis[3].data = masterDates;
    },
    InitOptions() {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.myChart);
      }

      if (this.TkKeytypeData.length > 0) {
        this.ChartGrid = WCITKOptions.Grid;
        this.ChartXAxis = WCITKOptions.xAxis;
        this.ChartYAxis = WCITKOptions.yAxis;
      } else {
        this.ChartGrid = WCIOptions.Grid;
        this.ChartXAxis = WCIOptions.xAxis;
        this.ChartYAxis = WCIOptions.yAxis;
      }

      const masterDates = this.SetWciUpChartDate();
      this.SetWciDownChartData(masterDates);

      if (this.TkKeytypeData.length > 0) {
        this.SetTkUpChartData(masterDates);
        this.SetTkDownChartData(masterDates);
      }

      this.ChartSeries = [
        ...this.wciUpSeriesData,
        ...this.wciDownSeriesData,
        ...this.tkUpSeriesData,
        ...this.tkDownSeriesData,
      ];

      this.chart.setOption(
        {
          color: [
            "#00DDFF",
            "#37A2FF",
            "#FF0087",
            "#FFBF00",
            "#FF7043",
            "#42A5F5",
            "#EF5350",
            "#FFA726",
            "#AB47BC",
            "#26C6DA",
            "#EC407A",
            "#29B6F6",
            "#8D6E63",
            "#78909C",
            "#BA68C8",
            "#D4E157",
            "#FF80AB",
            "#FFD54F",
            "#80D8FF",
            "#B39DDB",
          ],
          title: {
            text: this.ChartTitle,
            left: "center",
            top: 30,
            textStyle: {
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          legend: {
            orient: "vertical",
            left: 10,
            top: 60,
            data: this.legendData,
            textStyle: {
              fontSize: 12,
            },
          },
          grid: this.ChartGrid,
          axisPointer: {
            link: [
              {
                xAxisIndex: "all",
              },
            ],
            label: {
              backgroundColor: "#777",
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
            position: function (pos, params, el, elRect, size) {
              const obj = { top: 10 };
              obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
              return obj;
            },
            formatter: (params) => {
              if (!params || params.length === 0) return "";

              const fmt = (v) => {
                const n = parseFloat(v);
                return isNaN(n) ? "-" : n.toLocaleString();
              };

              let result = `<div style="padding: 10px 14px; font-size: 12px; min-width: 220px;">`;
              result += `<div style="font-weight: bold; font-size: 14px; text-align: center; margin-bottom: 8px; color: #333;">${params[0].name}</div>`;

              const wciTopParams = params.filter(
                (item) => item.axisIndex === 0 && item.value != null
              );
              const wciBottomParams = params.filter(
                (item) => item.axisIndex === 1 && item.value != null
              );

              if (wciTopParams.length > 0) {
                wciTopParams.forEach((item) => {
                  result += `<div style="display: flex; justify-content: space-between; align-items: center; margin: 1px 0;">
                    <span style="display: flex; align-items: center;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${item.color};margin-right:6px;"></span>${item.seriesName}</span>
                    <span style="font-weight: 500; color: #333;">${fmt(item.value)}</span>
                  </div>`;
                });
                const wciTotal = wciTopParams.reduce(
                  (sum, item) => sum + (parseFloat(item.value) || 0),
                  0
                );
                result += `<div style="display: flex; justify-content: space-between; margin: 4px 0 2px 0; border-top: 1px solid #e8e8e8; padding-top: 4px;">
                  <span style="font-weight: bold; color: #1890ff;">WCI总计</span>
                  <span style="font-weight: bold; color: #1890ff;">${fmt(wciTotal)}</span>
                </div>`;
              }

              if (wciBottomParams.length > 0) {
                wciBottomParams.forEach((item) => {
                  result += `<div style="display: flex; justify-content: space-between; align-items: center; margin: 1px 0;">
                    <span style="display: flex; align-items: center;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${item.color};margin-right:6px;"></span>WCI-${item.seriesName}</span>
                    <span style="font-weight: 500; color: #333;">${fmt(item.value)}</span>
                  </div>`;
                });
              }

              if (this.TkKeytypeData.length > 0) {
                result += `<div style="margin: 10px 0 4px 0; border-top: 1px solid #e8e8e8;"></div>`;

                const tkTopParams = params.filter(
                  (item) => item.axisIndex === 2 && item.value != null
                );
                const tkBottomParams = params.filter(
                  (item) => item.axisIndex === 3 && item.value != null
                );

                if (tkTopParams.length > 0) {
                  tkTopParams.forEach((item) => {
                    result += `<div style="display: flex; justify-content: space-between; align-items: center; margin: 1px 0;">
                      <span style="display: flex; align-items: center;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${item.color};margin-right:6px;"></span>${item.seriesName}</span>
                      <span style="font-weight: 500; color: #333;">${fmt(item.value)}</span>
                    </div>`;
                  });
                  const tkTotal = tkTopParams.reduce(
                    (sum, item) => sum + (parseFloat(item.value) || 0),
                    0
                  );
                  result += `<div style="display: flex; justify-content: space-between; margin: 4px 0 2px 0; border-top: 1px solid #e8e8e8; padding-top: 4px;">
                    <span style="font-weight: bold; color: #fa8c16;">TK总计</span>
                    <span style="font-weight: bold; color: #fa8c16;">${fmt(tkTotal)}</span>
                  </div>`;
                }

                if (tkBottomParams.length > 0) {
                  tkBottomParams.forEach((item) => {
                    result += `<div style="display: flex; justify-content: space-between; align-items: center; margin: 1px 0;">
                      <span style="display: flex; align-items: center;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${item.color};margin-right:6px;"></span>TK-${item.seriesName}</span>
                      <span style="font-weight: 500; color: #333;">${fmt(item.value)}</span>
                    </div>`;
                  });
                }
              }

              result += `</div>`;
              return result;
            },
          },
          dataZoom: [
            {
              type: "inside",
              xAxisIndex: this.TkKeytypeData.length > 0 ? [0, 1, 2, 3] : [0, 1],
              start: 0,
              end: 100,
            },
            {
              type: "slider",
              xAxisIndex: this.TkKeytypeData.length > 0 ? [0, 1, 2, 3] : [0, 1],
              start: 0,
              end: 100,
              bottom: 10,
            },
          ],
          toolbox: {
            right: 20,
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: this.ChartXAxis,
          yAxis: this.ChartYAxis,
          series: this.ChartSeries,
        },
        { notMerge: true }
      );
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  text-align: right;
  padding: 10px 20px 0 0;
}
.my-charts {
  width: 100%;
  height: 80vh;
}
</style>
